import Vue from 'vue';
import VueRouter from 'vue-router';

import { AUTH, ROUTE } from '@/constants';
import navigationGuard from './navigation-guard';
import assignmentRoute from './routes/assignment-route';
import archiveRoute from './routes/archive-route';
import certifiedTrainingRoute from './routes/certified-training-route';
import dashboardRoute from './routes/dashboard-route';
import dbExportRoute from './routes/db-export-route';
import exchangeRoute from './routes/exchange-route';
import loginRoute from './routes/login-route';
import myAccountRoute from './routes/my-account-route';
import notFoundRoute from './routes/not-found-route';
import operatorLogsRoute from './routes/operator-logs-route';
import preScreeningRoute from './routes/pre-screening-route';
import riskAssessmentRoute from './routes/risk-assessment-route';
import sarRoute from './routes/sar-route';
import txsMonitorRoute from './routes/txs-monitor-route';
import userManagementRoute from './routes/user-management-route';
import vaspRoute from './routes/vasp-route';
import verifiableCredentialsRoute from './routes/verifiable-credentials-route';

Vue.use(VueRouter);

const routes = [
  {
    path: ROUTE.PATH.ROOT,
    redirect: () => ROUTE.PATH.MY_ACCOUNT,
    meta: {
      auth: AUTH.USER_ROLE.AUTHORIZED,
    },
  },
];

routes.push(
  assignmentRoute,
  archiveRoute,
  certifiedTrainingRoute,
  dashboardRoute,
  dbExportRoute,
  exchangeRoute,
  loginRoute,
  myAccountRoute,
  operatorLogsRoute,
  preScreeningRoute,
  riskAssessmentRoute,
  sarRoute,
  txsMonitorRoute,
  userManagementRoute,
  vaspRoute,
  verifiableCredentialsRoute,
);
// Must be the last route
routes.push(notFoundRoute);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, _from, next) => {
  if (to.meta.auth === AUTH.USER_ROLE.ANY) {
    next();
    return;
  }

  const userRole = await navigationGuard.setupAuthorizationAndApp();
  if (userRole === AUTH.USER_ROLE.NOT_AUTHORIZED) {
    next(ROUTE.PATH.LOGIN);
    return;
  }

  await navigationGuard.setupApp();

  const onBoardingStatus = navigationGuard.getOnBoardingStatus();
  if (!onBoardingStatus) {
    const onBoardingUrl = process.env.VUE_APP_ONBOARDING_URL;
    window.location.replace(onBoardingUrl);
    return;
  }

  const isPermittedPath = navigationGuard.checkPermittedPath(to.matched);
  if (
    to.meta.tags
    && to.meta.tags.includes(onBoardingStatus)
    && isPermittedPath
  ) {
    next();
    return;
  }
  else {
    if (!isPermittedPath) {
      next({ name: ROUTE.NAME.MY_ACCOUNT });
      return;
    }
    else {
      const routeName = navigationGuard.setupDefaultRoute(onBoardingStatus);
      next({ name: routeName });
      return;
    }
  }
});

export default router;

export function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
